import React, { PropTypes } from 'react';

export function validateName(value) {
  if(!value.firstName || !value.lastName){
    return {
      ok: false,
      failed: {
        because: ['required'],
        value
      }
    }
  }
}

class Name extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this)
  }

  onChange(name){
    const {onChange} = this.props
    return (e) => {
      onChange({
        ...this.props.value,
        [name]: e.target.value
      })
    }
  }

  render() {
    const {
      value = {},
      onChange,
      label,
      required,
      className,
    } = this.props;

    return (
      <div className={'row ' + className}>
        <div className='col-xs-6'>
          <input className='form-control' value={value.firstName} onChange={this.onChange('firstName')} placeholder={__('First Name', 'createstudent')} />
        </div>
        <div className='col-xs-6'>
          <input className='form-control' value={value.lastName} onChange={this.onChange('lastName')} placeholder={__('Last Name', 'createstudent')} />
        </div>
      </div>

    );
  }
}

export default Name;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Name.js